import styled from 'styled-components'
import Button from 'components/Buttons'

export default styled(({ ...props }) => (
  <Button link {...props} />
))`
  padding: 0;
  text-transform: none;
`
